import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import { NameValue } from '../../shared/model/name-value.model';
import { HttpRequestService } from '../../shared/http/http-request.service';
import { HttpRequest } from '../../shared/http/http-request.model';
import { Table as PrimeDataTable } from 'primeng/table';

@Component({
  selector: 'wl-admin-http-request-items',
  templateUrl: 'http-request-items.component.html',
    standalone: false
})
export class HttpRequestItemsComponent implements OnInit {
  private _httpRequestService: HttpRequestService;
  private _utilService: UtilService;
  @ViewChild('requestItemsDataTable', { static: true }) _requestItemsDataTable: PrimeDataTable;
  public requestItems: Array<HttpRequest>;
  public showModal = false;

  public constructor(httpRequestService: HttpRequestService, utilService: UtilService) {
    this._httpRequestService = httpRequestService;
    this._utilService = utilService;

    this.requestItems = new Array<HttpRequest>();
  }
  ngOnInit(): void {
    this.refresh();
  }

  public show = (): void => {
    this.showModal = true;
  };

  public close = (): void => {
    this.showModal = false;
  };

  public refresh = (): void => {
    this.requestItems = new Array<HttpRequest>();
    this.requestItems = this._httpRequestService.getRequestItems();

    this._requestItemsDataTable.value = this.requestItems;
  };

  public removeRequestItem = (httpRequest: HttpRequest): void => {
    this._httpRequestService.removeRequestItem(httpRequest);
    this.refresh();
  };
}
